import { preinit } from "react-dom";
import {
	type FeatureStyle,
	featureStylePrecedence,
	getFeatureStyleHrefs,
} from "#/_packages/umbrella/components/ui/feature-styles";
import { discoverRendererTypes } from "./renderer-module";

const blockFeatures: Readonly<Record<string, FeatureStyle>> = {
	accordionUmbBlock: "accordion",
	carouselUmbBlock: "carousel",
	galleryUmbBlock: "gallery",
	keyFigureUmbBlock: "key-figure",
	submenuUmbBlock: "submenu",
	videoUmbBlock: "video",
};

export function getRendererStyleHrefs(value: unknown): string[] {
	return [
		...new Set(
			[...discoverRendererTypes(value)].flatMap((type) => {
				const feature = blockFeatures[type];
				return feature ? getFeatureStyleHrefs(feature) : [];
			}),
		),
	];
}

/** Start CSS alongside module imports on navigation; SSR links come from render. */
export function preinitRendererStyles(value: unknown) {
	if (typeof document === "undefined") return;
	for (const href of getRendererStyleHrefs(value)) {
		preinit(href, { as: "style", precedence: featureStylePrecedence });
	}
}
